module.exports = __webpack_public_path__ + "img/baodan.c3244ee0.png";